import { curry2 } from '@most/prelude';
export var error = curry2(function error(err, subject) {
    return subject.error(err);
});
//# sourceMappingURL=error.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/most-subject/lib/es2015/combinators/error.js
// module id = 864
// module chunks = 0